<button (click)="onClick.emit()"
        attr.aria-label="{{ 'profileRemoveFieldLabel' | translate }} {{inputValue ? inputValue : emptyField}} "
        [attr.aria-controls]="controlsId"
        class="app-button profile-remove-button h-100 px-3"
        data-automation-id="profile-remove-field-button">
  <fa-icon [icon]="timesIcon"></fa-icon>
</button>
